import { Box } from '@material-ui/core';
import SubscriptionLogoStatus from '../subscriptionLogoStatus';
import SubscriptionList from '../subscriptionList';

export const CancelSubscriptionInfo = ({
  subscriptionListClasses,
  imageUrl,
  statusName,
  planImageList,
  subscriptionList,
}) => (
  <Box display="flex" flexDirection="column" gridRowGap={16} width={'100%'}>
    <SubscriptionLogoStatus
      classes={subscriptionListClasses}
      imageUrl={imageUrl}
      statusName={statusName}
      planImageList={planImageList}
    />
    <Box>
      {subscriptionList.map((item) => (
        <SubscriptionList
          classes={subscriptionListClasses}
          name={item.name}
          value={item.value}
          key={item.id}
        />
      ))}
    </Box>
  </Box>
);
